import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
    Input, Select,
} from '../../../../../../_metronic/_partials/controls';
import { getFundTypeForProgramCombobox } from '../../../_redux/fund_type/fundtypeCrud'
import { getBranchAll } from '../../../_redux/branchs/branchCrud';

// Validation schema
const ProgramEditSchema = Yup.object().shape({
    name: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Name wajb diisi'),
    fund_type_code: Yup.string()
        .required('Type wajb diisi'),
});

export function ProgramEditForm({ saveProgram, actionsLoading, program, onHide }) {
    const [fundTypeList, setFundTypeList] = useState([]);
    const [fundBranchList, setBranchList] = useState([]);
    useEffect(() => {
        const fetchType = async () => {
            const result = await getFundTypeForProgramCombobox();
            setFundTypeList(result.data.data);
        };
        fetchType();
        const fetchBranch = async () => {
            const result = await getBranchAll();
            setBranchList(result.data.data);
        };
        fetchBranch()
    }, []);

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={program}
                validationSchema={ProgramEditSchema}
                onSubmit={(values) =>
                    saveProgram(values)
                }
            >
                {({ handleSubmit, handleChange, setFieldValue }) => (
                    <>
                        <Modal.Body className="overlay overlay-block cursor-default">
                            {actionsLoading && (
                                <div className="overlay-layer bg-transparent">
                                    <div className="spinner spinner-lg spinner-success" />
                                </div>
                            )}
                            <Form className="form form-label-right">
                                <div className="form-group row">
                                    <div className="col-lg-6">
                                        <Field
                                            name="name"
                                            component={Input}
                                            placeholder="Text"
                                            label="Name"
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <Select
                                            name="fund_type_code"
                                            label="Type"
                                            onChange={(e) => {
                                                handleChange(e)
                                                const fundTypeChoosen = fundTypeList.find((item) => item.code == e.target.value)
                                                if (fundTypeChoosen) {

                                                    setFieldValue("fund_type_uuid", fundTypeChoosen.uuid)
                                                } else {
                                                    setFieldValue("fund_type_uuid", null)

                                                }
                                            }}>
                                            <option value="">--PILIH--</option>
                                            {
                                                fundTypeList.map(row =>
                                                    <option key={row.code} value={row.code}>{row.name}</option>
                                                )
                                            }
                                        </Select>
                                        <ErrorMessage name='fund_type_code'
                                            render={msg => <div style={{ color: 'red' }}>{msg}</div>} />

                                    </div>
                                </div>

                                <div className="form-group row">
                                    {/* <div className="col-lg-6">
                                        <Select
                                            name="branch_uuid"
                                            label="Branch"
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}>
                                            <option value="">--PILIH--</option>
                                            {
                                                fundBranchList.map(row =>
                                                    <option key={row.code} value={row.uuid}>{row.name}</option>
                                                )
                                            }
                                        </Select>
                                        <ErrorMessage name='branch_uuid'
                                            render={msg => <div style={{ color: 'red' }}>{msg}</div>} />

                                    </div> */}
                                </div>

                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                            >
                                Cancel
                            </button>
                            <> </>
                            <button
                                type="submit"
                                onClick={() => handleSubmit()}
                                className="btn btn-primary btn-elevate"
                            >
                                Save
                            </button>
                        </Modal.Footer>
                    </>
                )}
            </Formik>
        </>
    );
}

